import React from 'react';

interface TextAreaProps {
  label?: string;
  placeholder?: string;
  value: string;
  onChange: (value: string) => void;
  required?: boolean;
  error?: string;
  disabled?: boolean;
  rows?: number;
  maxLength?: number;
  className?: string;
  hint?: string;
}

const TextArea: React.FC<TextAreaProps> = ({
  label,
  placeholder,
  value,
  onChange,
  required = false,
  error,
  disabled = false,
  rows = 4,
  maxLength,
  className = '',
  hint,
}) => {
  return (
    <div className={`font-['Inter',sans-serif] ${className}`}>
      <style>
        {`
          @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');
        `}
      </style>

      {label && (
        <label className="block text-base font-medium text-[#1F1F1F] mb-2 leading-[1.75em]">
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}

      <textarea
        value={value}
        onChange={e => onChange(e.target.value)}
        placeholder={placeholder}
        disabled={disabled}
        rows={rows}
        maxLength={maxLength}
        className={`block w-full px-4 py-3 border rounded-lg text-base transition-all duration-200 resize-vertical font-normal leading-[1.75em] ${
          error
            ? 'border-red-300 focus:border-red-500 focus:ring-red-500'
            : 'border-gray-300 focus:border-[var(--brand-primary)] focus:ring-[var(--brand-primary)]'
        } ${
          disabled
            ? 'bg-gray-50 text-[#6E7077] cursor-not-allowed'
            : 'bg-white hover:border-[var(--brand-primary)] text-[#1F1F1F]'
        } focus:outline-none focus:ring-2 focus:ring-opacity-20 placeholder-[#6E7077]`}
      />

      <div className="flex justify-between items-center mt-2">
        <div>
          {error && <p className="text-sm text-red-600 font-normal leading-[1.75em]">{error}</p>}
          {hint && !error && (
            <p className="text-sm text-[#6E7077] font-normal leading-[1.75em]">{hint}</p>
          )}
        </div>
        {maxLength && (
          <p className="text-sm text-[#6E7077] font-normal leading-[1.75em]">
            {value.length}/{maxLength}
          </p>
        )}
      </div>
    </div>
  );
};

export default TextArea;
